"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigninWithPasswordForm = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
require("./SigninWithPasswordForm.scss");
const SigninWithPasswordForm_scss_json_1 = __importDefault(require("./SigninWithPasswordForm.scss.json"));
const TextField_1 = require("lincd-input/lib/components/TextField");
const Modal_1 = require("lincd-mui-base/lib/components/Modal");
const CreateAccountForm_1 = __importDefault(require("./CreateAccountForm"));
const ForgotPasswordForm_1 = __importDefault(require("./ForgotPasswordForm"));
const useAuth_1 = require("../hooks/useAuth");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const Button_1 = require("lincd-mui-base/lib/components/Button");
const package_1 = require("../package");
const react_router_dom_1 = require("react-router-dom");
const SigninWithPasswordForm = ({ onCreateAccount, onLoggedIn, className, onLoginFailed, startWithInputField, onForgotPassword, showEmailIcon, buttonClassName, onLoadingChange, // callback function invoked when the loading state changes, you can pass a function to handle the loading state when call the server
 }) => {
    const { register, handleSubmit, formState: { errors }, trigger, watch, reset, resetField, getValues, } = (0, react_hook_form_1.useForm)({ mode: 'all' });
    const [formIsHidden, setFormIsHidden] = (0, react_1.useState)(false);
    const [showInputField, setShowInputField] = (0, react_1.useState)(startWithInputField || false);
    const [showCreateAccountModal, setShowCreateAccountModal] = (0, react_1.useState)(false);
    const [showForgotPasswordModal, setShowForgotPasswordModal] = (0, react_1.useState)(false);
    const auth = (0, useAuth_1.useAuth)();
    const [searchParam] = (0, react_router_dom_1.useSearchParams)();
    const adminLogin = () => {
        return Server_1.Server.call(package_1.packageName, 'signinDevelopment', searchParam.get('email')).then((response) => {
            if (response.auth) {
                const result = auth.updateAuth(response.auth, response.accessToken, response.refreshToken);
                if (onLoggedIn) {
                    onLoggedIn(result);
                }
                return true;
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (searchParam.get('email') && process.env.NODE_ENV !== 'production') {
            adminLogin();
        }
    }, [searchParam]);
    const createAccountRedirect = () => {
        onCreateAccount
            ? //if onCreateAccount props available,
                //redirect to that page, otherwise use create account modal popup
                onCreateAccount()
            : setShowCreateAccountModal(true);
    };
    const onSignIn = (data, e) => {
        e.preventDefault();
        const { email, password } = data;
        // if onLoadingChange prop is passed, invoke it with true
        if (onLoadingChange) {
            onLoadingChange(true);
        }
        Server_1.Server.call(package_1.packageName, 'signinWithPassword', email, password)
            .then((response) => {
            if (response.auth) {
                const result = auth.updateAuth(response.auth, response.accessToken, response.refreshToken);
                //temporary way for admin to login as other users
                if (searchParam.get('email') &&
                    process.env.NODE_ENV === 'production') {
                    adminLogin().then((loggedIn) => {
                        if (!loggedIn && onLoggedIn) {
                            onLoggedIn(result);
                        }
                    });
                }
                else if (onLoggedIn) {
                    onLoggedIn(result);
                }
            }
            if (!response || response.error) {
                alert('Incorrect email and password combination');
                reset();
                setFormIsHidden(false);
                // window.location.reload();
                // if onLoadingChange prop is passed, invoke it with false
                if (onLoadingChange) {
                    onLoadingChange(false);
                }
            }
        })
            .catch((err) => {
            console.error('Error signinWithPassword ', err);
        })
            .finally(() => {
            // if onLoadingChange prop is passed, invoke it with false
            if (onLoadingChange) {
                onLoadingChange(false);
            }
        });
    };
    const onNextForm = () => {
        const emailValue = getValues('email');
        const emailError = errors.email;
        if (!emailValue || emailError) {
            trigger('email');
        }
        else {
            // Rest of your code
            setFormIsHidden(true);
        }
    };
    return (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(SigninWithPasswordForm_scss_json_1.default.root, className) },
        react_1.default.createElement("form", { className: SigninWithPasswordForm_scss_json_1.default.form },
            react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(formIsHidden ? SigninWithPasswordForm_scss_json_1.default.hidden : null) },
                !showInputField ? (react_1.default.createElement(Button_1.Button, { className: buttonClassName, onClick: () => setShowInputField(true), variant: "outlined", fullWidth: true, startIcon: showEmailIcon && (react_1.default.createElement("img", { src: "/images/email.png", alt: "email-icon", className: SigninWithPasswordForm_scss_json_1.default.iconButton })) }, "Continue with Email")) : (react_1.default.createElement(TextField_1.TextField, Object.assign({ type: 'email', placeholder: "type your@email here" }, register('email', {
                    required: true,
                    pattern: {
                        value: /\S+@\S+\.\S+/,
                        message: 'Entered value does not match email format',
                    },
                }), { endAdornment: react_1.default.createElement("div", { className: SigninWithPasswordForm_scss_json_1.default.end },
                        react_1.default.createElement("button", { className: SigninWithPasswordForm_scss_json_1.default.button, type: "button", onClick: onNextForm },
                            react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", stroke: "currentColor" },
                                react_1.default.createElement("path", { d: "M4 12h16m0 0-6-6m6 6-6 6", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))) }))),
                errors.email && (react_1.default.createElement("p", { className: SigninWithPasswordForm_scss_json_1.default.errorMessage }, "Please type your valid email"))),
            react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(!formIsHidden ? SigninWithPasswordForm_scss_json_1.default.hidden : null) },
                react_1.default.createElement(TextField_1.TextField, Object.assign({ type: 'password', placeholder: "type your password here" }, register('password', { required: true }), { endAdornment: react_1.default.createElement("div", { className: SigninWithPasswordForm_scss_json_1.default.end },
                        react_1.default.createElement("button", { className: SigninWithPasswordForm_scss_json_1.default.button, onClick: handleSubmit(onSignIn) },
                            react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", stroke: "currentColor" },
                                react_1.default.createElement("path", { d: "M4 12h16m0 0-6-6m6 6-6 6", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))) })),
                errors.password && (react_1.default.createElement("p", { className: SigninWithPasswordForm_scss_json_1.default.errorMessage }, "Please type your password")))),
        showInputField && (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(SigninWithPasswordForm_scss_json_1.default.bottomSection, errors.email || errors.password ? SigninWithPasswordForm_scss_json_1.default.ExtraSpace : null) },
            react_1.default.createElement("p", { className: SigninWithPasswordForm_scss_json_1.default.createAccount, onClick: createAccountRedirect }, "Create account"),
            react_1.default.createElement("p", { className: SigninWithPasswordForm_scss_json_1.default.forgotPassword, onClick: () => setShowForgotPasswordModal(true) }, "Forgot password?"))),
        react_1.default.createElement(Modal_1.Modal, { isOpen: showCreateAccountModal, backdrop: "rgba(0, 0, 0, 0.8)", onClose: () => setShowCreateAccountModal(false) },
            react_1.default.createElement(CreateAccountForm_1.default, { className: SigninWithPasswordForm_scss_json_1.default.modalForm, onAccountCreated: (auth) => {
                    setShowCreateAccountModal(false);
                    onLoggedIn(auth);
                } })),
        react_1.default.createElement(Modal_1.Modal, { isOpen: showForgotPasswordModal, backdrop: "rgba(0, 0, 0, 0.8)", onClose: () => setShowForgotPasswordModal(false), renderContent: react_1.default.createElement(ForgotPasswordForm_1.default, { className: SigninWithPasswordForm_scss_json_1.default.modalForm }) })));
};
exports.SigninWithPasswordForm = SigninWithPasswordForm;
//# sourceMappingURL=SigninWithPasswordForm.js.map